import qs from 'qs'

import { logger } from 'utils/logger'

import axiosInstance from '../httpInstance/twilioAxios'

const ghostUserRules = identity => {
    let rules = qs.stringify({
        Rules:
            '[{ "type": "include", "all": true },{ "type": "exclude", "publisher":"' +
            identity +
            '"}]',
    })
    return rules
}

export const unsubscribeGhostUser = (identity, roomSid, participantSid) => {
    let currentRules = axiosInstance(null, roomSid, participantSid)

    currentRules.then(function(response) {
        let rules
        if (response.data) rules = response.data.rules
        if (rules) rules = ghostUserRules(identity)
        return axiosInstance(rules, roomSid, participantSid)
            .then(function(response) {
                console.log(response)
            })
            .catch(function(error) {
                const logErrorMsg = `Failed to subscribe to selected audio.\nERROR: ${JSON.stringify(
                    error
                )}`
                logger.error(logErrorMsg)
            })
    })
}
